import React from "react";
import PropTypes from "prop-types";
import { Tooltip } from "antd";
function ATSToolTip(props) {
    const {text, placement, children} = props
  return (
    <Tooltip placement={placement || "top"} overlayClassName="ats-tooltip-overlay" overlayInnerStyle={{
        color: "#000",
        border: "1px solid #000"
    }} arrowContent={<span>Hello</span>} title={text} color="#fff">
      {children}
    </Tooltip>
  );
}

ATSToolTip.propTypes = {
    text: PropTypes.string.isRequired,
    placement: PropTypes.string,
    children: PropTypes.node.isRequired
};

export default ATSToolTip;
